import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { closeDetailsDrawer } from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";
import { theme } from "../../../Theme";
import { PROMO_COLORS } from "../constants/colors";
import KPICards from "./KPICards";
import WarningBadges from "./WarningBadges";

export default function DetailsDrawer() {
  const dispatch = useDispatch();
  const { detailsDrawerOpen, drawerScenarioId, scenarios } = useSelector(
    (state) => state.promoSimulator
  );

  const scenario = scenarios.find((s) => s.id === drawerScenarioId);

  return (
    <Drawer
      anchor="right"
      open={detailsDrawerOpen}
      onClose={() => dispatch(closeDetailsDrawer())}
      PaperProps={{ sx: { width: { xs: "100%", sm: 700 }, p: 3 } }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          color={theme.palette.primary.main}
        >
          Scenario Details
        </Typography>
        <IconButton onClick={() => dispatch(closeDetailsDrawer())}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ mb: 2 }} />

      {!scenario ? (
        <Typography color="text.secondary">Scenario not found.</Typography>
      ) : (
        <Box>
          <Typography variant="h6" fontWeight={600} mb={0.5}>
            {scenario.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2.5}>
            Created: {new Date(scenario.createdAt).toLocaleDateString()}
          </Typography>

          <Grid container spacing={1} mb={2.5}>
            {[
              { label: "Brand", value: scenario.brand },
              {
                label: "SKUs",
                value: Array.isArray(scenario.skus)
                  ? scenario.skus.join(", ")
                  : scenario.skus,
              },
              {
                label: "Period",
                value:
                  typeof scenario.weeks?.week === "number"
                    ? `Week ${scenario.weeks.week}`
                    : `${scenario.weeks?.start ?? "—"} → ${scenario.weeks?.end ?? "—"}`,
              },
              { label: "Discount", value: `${scenario.discountPct}%` },
            ].map(({ label, value }) => (
              <Grid item xs={6} key={label}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: "1px solid #F2F4F7",
                  }}
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    {label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {value}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Typography
            variant="subtitle2"
            fontWeight={700}
            mb={1.5}
            color={theme.palette.primary.main}
          >
            KPIs
          </Typography>
          <KPICards kpis={scenario.kpis || {}} />

          {(scenario.warnings || []).length > 0 && (
            <Box mt={2.5}>
              <Typography
                variant="subtitle2"
                fontWeight={700}
                mb={1}
                color={PROMO_COLORS.accentMain}
              >
                Warnings
              </Typography>
              <WarningBadges warnings={scenario.warnings} />
            </Box>
          )}
        </Box>
      )}
    </Drawer>
  );
}
